import { PagedServiceParams } from '../common';

export const addContinuationTokenToQuery = <T>(params: PagedServiceParams<T>): T => ({
    ...params.params,
    _continuation_token: params.pageParam,
});
